import { Routes, Route } from 'react-router'
import Home from './Home/Home'
import NotFound from './NotFound/NotFound'
import Login from './Login/Login'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorPage from '@components/ErrorBoundary/ErrorPage/ErrorPage'
import RequireAuth from '@components/RequireAuth/RequireAuth'
import RequireGuest from '@components/RequireGuest/RequireGuest'
import PageLayout from 'src/layouts/PageLayout/PageLayout'
import Company from './Company/Company'
import DataSetInfo from './DataSetInfo/DataSetInfo'

export default function App() {
  return (
    <ErrorBoundary errorComponent={ErrorPage}>
      <Routes>
        <Route element={<RequireAuth />}>
          <Route element={<PageLayout />}>
            <Route path="/" element={<Home />} index />
            <Route path="/company/:id" element={<Company />} />
            <Route
              path="/company/:companyId/dataset/:datasetId"
              element={<DataSetInfo />}
            />
          </Route>
        </Route>
        <Route element={<RequireGuest />}>
          <Route path="/login" element={<Login />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ErrorBoundary>
  )
}
